(function () {
  "use strict";

  angular.module("alk.directives", ["alk.services", "alk.filters"]);

  angular
    .module("alk.directives")
    .directive("onlyDigits", function () {

      return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ctrl) {
          function inputValue(val) {
            if (val) {
              var digits = val.replace(/[^0-9]/g, '');

              if (digits !== val) {
                ctrl.$setViewValue(digits);
                ctrl.$render();
              }
              return parseInt(digits, 10);
            }
            return undefined;
          }
          ctrl.$parsers.push(inputValue);
        }
      };
    });

  angular
    .module("alk.directives")
    .directive("alkInteger",
      function () {
        return {
          require: "ngModel",
          link: function (scope, elm, attrs, ctrl) {
            var INTEGER_REGEXP = /^\d+$/;

            function integerValidation(val) {
              if (!val || INTEGER_REGEXP.test(val)) {
                ctrl.$setValidity("pcmInteger", true);
                return val;
              } else {
                ctrl.$setValidity("pcmInteger", false);
                return undefined;
              }
            }

            ctrl.$parsers.unshift(integerValidation);
            ctrl.$formatters.unshift(integerValidation);
          }
        };
      });

  angular
    .module("alk.directives")
    .directive("copyrightText", function ($compile) {
      return {
        scope: {
          type: "@"
        },
        restrict: "AE",
        replace: true,
        link: function (scope, elem, attrs) { // jshint ignore:line
          var templates = {
            Default: "<span class=\"copyright-text\">Copyright &copy; <a target=\"_blank\" href=\"https://maps.trimble.com\">Trimble, Inc.</a> 1986-{{year}}</span>",
            WebUI: "<span class=\"copyright-text\">Copyright &copy; 2010-{{year}} Trimble, Inc. All Rights Reserved.</span>"
          };
          scope.year = new Date().getFullYear();
          var html = "";
          if (scope.type === "WebUI") {
            html = templates.WebUI;
          } else {
            html = templates.Default;
          }
          elem.replaceWith($compile(html)(scope));
        }
      };
    });

  angular
    .module("alk.directives")
    .directive("alkEmail", function () {
      var REGEX_EMAIL = /^([\w!#$%&"*+\/=?^_`{|}~.-]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;

      return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
          ngModel.$validators.alkEmail = function (modelValue) {
            if (modelValue === null || modelValue === "") {
              return true;
            }
            return REGEX_EMAIL.test(modelValue);
          };
        }
      };
    });

  angular
    .module("alk.directives")
    .directive("alkCompare", function () {
      var d = {
        restrict: "A",
        require: "ngModel",
        scope: {},
        link: function (scope, element, attr, control) {
          scope.$watch("alkCompare", function () {
            control.$validate();
          });

          control.$validators.alkCompare = function (modelValue, viewValue) {
            var value = modelValue || viewValue;
            var other = scope.alkCompare;
            return value === other;
          };
        }
      };

      d.scope.alkCompare = "=";

      return d;
    });

  angular
    .module("alk.directives")
    .directive("alkSubmit", ["$parse", "$timeout", function ($parse, $timeout) {
      return {
        restrict: "A",
        require: ["form"],
        link: function (scope, element, attrs, controllers) {
          var formController = controllers[0];
          var fn = $parse(attrs.alkSubmit);
          var submitIfFn;

          if (attrs.alkSubmitIf) {
            submitIfFn = $parse(attrs.alkSubmitIf);
          }

          formController.shouldSubmit = function (event) {
            if (typeof submitIfFn === "function" && submitIfFn(scope, {
                $event: event
              }) === false) {
              return false;
            }

            return true;
          };

          formController.needsAttention = function (field) {
            return field.$invalid && formController.submitted;
          };

          formController.setSubmitted = function (val) {
            formController.submitted = val;
            if (!scope.$$phase) scope.$apply();
          };

          element.bind("submit", function (event) {
            if (formController.shouldSubmit(event) === false) {
              return;
            }

            formController.setSubmitted(true);

            if (!scope.$$phase) scope.$apply();

            if (!formController.$valid) return false;

            $timeout(function () {
              formController.setSubmitted(false);
              fn(scope, {
                $event: event
              });
            });
          });
        }
      };
    }]);

  angular
    .module("alk.directives")
    .directive("alkMessages", ["Messages", "_", function (Messages, _) {

      var templateString =
        "<div id=\"messages\">" +
        "<div class=\"alert alert-{{ message.type }}\" ng-repeat=\"message in messages\">" +
        "<a class=\"close\" ng-click=\"closeMessage(message)\" data-dismiss=\"alert\">&times;</a>" +
        "<span ng-bind-html=\"message.message | unsafe\"></span>" +
        "</div>" +
        "</div>";

      return {
        restrict: "E",
        template: templateString,
        scope: {},
        controller: ["$scope", function ($scope) {
          var messages = Messages.getMessages();

          for (var i = 0; i < messages.length; i++) {
            messages[i].read = true;
          }
          $scope.messages = messages;

          $scope.closeMessage = function (message) {
            message.closed = true;
            var index = $scope.messages.indexOf(message);
            $scope.messages.splice(index, 1);
          };

          $scope.$watchCollection(function () {
            return Messages.getMessages();
          }, function (messages) {
            for (var j = 0; j < messages.length; j++) {
              messages[j].read = true;
            }
            $scope.messages = messages;
          });

        }],
        link: function (scope, element, attrs) {

        }
      };
    }]);



  angular
    .module("alk.directives")
    .directive("alkAutofocus", ["$timeout", "$parse", function ($timeout, $parse) {
      return {
        restrict: "A",
        link: function ($scope, $element, attrs) {
          if (attrs.alkAutofocus === "" || $parse(attrs.alkAutofocus)($scope)) {
            $timeout(function () {
              $element[0].focus();
            });
          }
        }
      };
    }]);

  angular
    .module("alk.directives")
    .directive("alkDisabled", [function () {
      return {
        restrict: "A",
        scope: {
          alkDisabled: "="
        },
        controller: ["$scope", function ($scope) {
          this.getDisabled = function () {
            return $scope.alkDisabled;
          };
        }]
      };
    }]);

  var disabledInputDirective = [function () {
    return {
      restrict: "E",
      require: "?^alkDisabled",
      link: function ($scope, $element, attrs, alkDisableController) {
        if (!alkDisableController) return;

        $scope.$watch(function () {
          return alkDisableController.getDisabled();
        }, function (newValue, oldValue) {
          if (newValue === true) {
            $element.attr("disabled", "disabled");
          } else {
            $element.removeAttr("disabled");
          }

        }, true);
      }
    };
  }];

  angular
    .module("alk.directives")
    .directive("button", disabledInputDirective)
    .directive("select", disabledInputDirective)
    .directive("input", disabledInputDirective);

  var mapsInputDirective = ["$rootScope", function ($rootScope) {
    return {
      restrict: "E",
      require: "?^alkmap",
      link: function ($scope, $element, attrs, alkMapController) {
        if (!alkMapController) {
          $element.on("focus", function ( /* event */ ) {
            $rootScope.$broadcast("MapInputFocus", $element);
          });

          $element.on("blur", function () {
            $rootScope.$broadcast("MapInputBlur", $element);
          });
        }
      }
    };
  }];

  angular
    .module("alk.directives")
    .directive("input", mapsInputDirective)
    .directive("textarea", mapsInputDirective);

  angular
    .module("alk.directives")
    .directive("alkmapsInput", ["$rootScope",
      function alkmapsInput($rootScope) {
        function link(scope, element /*, attrs */ ) {
          element.on("focus", function ( /* event */ ) {
            $rootScope.$broadcast("MapInputFocus", element);
          });

          element.on("blur", function () {
            $rootScope.$broadcast("MapInputBlur", element);
          });
        }

        var directive = {
          link: link,
          restrict: "A",
          scope: {}
        };

        return directive;
      }
    ]);

  angular
    .module("alk.directives")
    .directive("includeReplace", function () {
      return {
        require: "ngInclude",
        restrict: "A",
        link: function (scope, el, attrs) {
          el.replaceWith(el.children());
        }
      };
    });

})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/Common/common-directives.js